import { createSelector, type Selector } from '@reduxjs/toolkit';
import { SessionConnectionStatus } from '../../webrtc/session';
import { type RootState } from '../../stores/redux';
import { getAllMembersMap } from '../realtime/realtime.selectors';

const getState = (state: RootState): RootState => state;

const getSessionState = createSelector(
  getState,
  (state: RootState) => state.session,
);

export const getSessionParticipantsMap = (state: RootState) =>
  state.session.participantsMap;

export const getAllSessionParticipantsMap = (state: RootState) =>
  state.session.allParticipantsMap;

export const getSessionParticipantsIds = createSelector(
  getSessionParticipantsMap,
  (participantsMap) => Object.keys(participantsMap),
);

export const getSessionParticipants = createSelector(
  getSessionParticipantsMap,
  (participantsMap) => Object.values(participantsMap),
);

export const getPendingParticipants = createSelector(
  getSessionState,
  (state) => state.pendingParticipants ?? {},
);

export const getRemovingParticipantTimes = (state: RootState) =>
  state.session.removingParticipantTimes;

export const getIsInGroupCall = createSelector(
  getSessionParticipantsIds,
  (participantsIds) => participantsIds.length > 1,
);

export const getSessionDetails = createSelector(getSessionState, (state) => ({
  isConnected: state.connectionStatus === SessionConnectionStatus.Connected,
  connectionStatus: state.connectionStatus,
  isLoading: state.isLoading,
  sessionId: state.sessionId,
}));

export const getIsParticipantPending: Selector<RootState, boolean> =
  createSelector(
    [
      getPendingParticipants,
      getAllMembersMap,
      (_, participantId: string) => participantId,
    ],
    (pendingParticipants, membersMap, participantId) => {
      const participantLegacyId =
        membersMap[participantId]?.state.legacyIdentityId;

      return (
        participantId in pendingParticipants ||
        (participantLegacyId !== undefined &&
          participantLegacyId in pendingParticipants)
      );
    },
  );
